/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: unified
 */
import React from 'react';
import { Text, TouchableOpacity } from 'react-native';
import { ChipWrapRow } from '../ui/ChipWrapRow';
import { operationalFilterStyles } from './operationalFilters.styles';

type Option<T extends string> = {
  value: T;
  label: string;
};

type Props<T extends string> = {
  options: readonly Option<T>[];
  value: T;
  onChange: (value: T) => void;
  style?: React.ComponentProps<typeof ChipWrapRow>['style'];
  /** Brand-solid selected state on ticket surfaces. */
  ticketTone?: boolean;
};

/** Chips de selección única (filtros operativos / formularios en modales). */
export function OperationalChipSelectRow<T extends string>({
  options,
  value,
  onChange,
  style,
  ticketTone = false,
}: Props<T>) {
  return (
    <ChipWrapRow style={style}>
      {options.map((opt) => {
        const selected = value === opt.value;
        return (
          <TouchableOpacity
            key={opt.value}
            accessibilityRole="button"
            accessibilityState={{ selected }}
            style={[
              operationalFilterStyles.chip,
              ticketTone && operationalFilterStyles.chipTicket,
              selected &&
                (ticketTone
                  ? operationalFilterStyles.chipActiveTicket
                  : operationalFilterStyles.chipActive),
            ]}
            onPress={() => onChange(opt.value)}
          >
            <Text
              style={[
                operationalFilterStyles.chipText,
                ticketTone && operationalFilterStyles.chipTextTicket,
                selected &&
                  (ticketTone
                    ? operationalFilterStyles.chipTextActiveTicket
                    : operationalFilterStyles.chipTextActive),
              ]}
            >
              {opt.label}
            </Text>
          </TouchableOpacity>
        );
      })}
    </ChipWrapRow>
  );
}
